
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pakkereiser/ut",
      function () {
        return require("private-next-pages/pakkereiser/ut.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pakkereiser/ut"])
      });
    }
  